<template lang="pug">
#leads-details.grid-box.grid-col.scroll-y
    .loading-container(v-if="props.loading")
        .loading-circle
    form.top-section.grid-box.grid-row.grid-col

        .text-input.input-el.col-1.row-1
            span.label Full Name
                //- :value="fullName"
            input.input-box.text(
                v-model="selectedItem.name.fullName"
                placeholder="Jean C. Lupus"
                type="text"
            )

        .text-input.input-el.col-1.row-2
            span.label Email
            input.input-box.text(
                v-model="selectedItem.email"
                placeholder="email@example.com"
                type="email"
            )
            span.err(v-if="errorMessages?.email && errorMessages.email.length > 0") {{ errorMessages.email }}
        .grid-row.grid-row.row-auto.phone-postal.col-1.row-3
            .text-input.input-el
                span.label Phone Number
                input.input-box.text(
                    v-model="selectedItem.phone"
                    placeholder="555-555-5555"
                    type="tel"
                    pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"

                )
            .text-input.input-el
                span.label Postal Code
                input.input-box.text(
                    v-model="selectedItem.postalCode"
                    placeholder="00000"
                    type="text"
                    pattern="[0-9]{5}-[0-9]{4}?"
                )

        .grid-row.row-auto.col-2.row-1
            .text-input.input-el(@click="checkDate()")
                    span.label Last Contacted
                    input.input-box.text.date-selector(
                        id="datepicker"
                        v-model="selectedItem.lastContact"
                        placeholder="mm/dd/yyyy"
                        type="date"
                        max="currentDay"
                    )
            .input-el.select-el
                span.label Status
                span.chevron
                    include ../../../library/src/resources/icons/chevron-down.pug
                select(v-model="selectedItem.status")
                    option(
                        v-for="option in activityStatusOptions"
                        :key="option"
                        :value="option"
                    ) {{option}}
        .input-el.select-el.col-2.row-2
            span.label( ) Interested In
            span.chevron
                include ../../../library/src/resources/icons/chevron-down.pug
            select(v-model="selectedItem.productInterest")
                option(
                    v-for="option in interestOptions"
                    :key="option"
                    :value="option"
                ) {{option}}
        .input-el.select-el.col-2.row-3
            span.label( ) Origin
            span.chevron
                include ../../../library/src/resources/icons/chevron-down.pug
            select(v-model="selectedItem.leadOrigin")
                option(
                    v-for="option in originOptions"
                    :key="option"
                    :value="option"
                ) {{option}}
        .grid-row.buttons.row-4
            span.buttons
                p Create Customer Account for Lead
                button.secondary.outline.createCust(
                    :disabled="!checkStatus"
                    @click="createCustAccount"
            ) Create
            span.buttons
                p Send Email to Lead
                button.secondary.outline.createCust(
                    @click="generateEmail(email, interest)"
                ) Email
    .grid-row.fill-space
        .text-input.input-el.text-area-el.fill-space
            span.label Notes
            textarea.fill-space(
                v-model="selectedItem.notes"
            )
</template>
<script setup lang="ts">

/**
 * TODO:
 * - Need to make props non-mutable
 * - POSTAL CODE: Add postal code to user model, and display it here. Should also be editable
 */

import { Leads, CONSTANTS } from "@busy-human/k9-library";
import { computed } from "vue";

type Lead = Leads.Model
type Props = {
	leadItem : Lead,
	loading  : boolean,
	checkStatus : boolean,
	email: string,
	interest: string,
	errorMessages: {
		[key: string]: string,
	}
}

const props = defineProps<Props>();

type Emits = {
	(e: "createCustAcct", leadId: string):void
}

const selectedItem = computed(()=>props.leadItem);

/** Emit: Create Customer Account */
const emit = defineEmits<Emits>();

const interestOptions       = CONSTANTS.PRODUCT_INTEREST;
const originOptions         = CONSTANTS.LEAD_ORIGIN;
const activityStatusOptions = CONSTANTS.STATUS;

const createCustAccount = () => {
	try {
		const leadId = props.leadItem._id;
		emit("createCustAcct", leadId);

	} catch (err) {
		console.log("The error was:", err);
	}
};

const checkDate = () => {
	const [currentDay] = new Date().toISOString().split('T');
	document.getElementById("datepicker")?.setAttribute("max", currentDay);
};

const generateEmail = (email: string, interest: string) => {
	try {
		window.open(`mailto:${  email  }?subject=Hello from Canine Revolution&body=Thank you for your interest in Canine Revolution Dog Training. Are there any questions we can answer about your interest in ${  interest  }? ` + `We are happy to help in any way we can, and hope to hear from you soon.`);
	} catch (err) {
		console.log("The error was:", err);
	}
};

</script>
<style lang="scss">
/* Moved to ./stylesheets/leads-page.scss */
</style>